"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getShadow = void 0;

var ui_symbols_1 = require("@hopin-team/ui-symbols");

var SHADOWS = ui_symbols_1.PLANE.SHADOWS;

var getShadow = function getShadow(level, theme) {
  var _a, _b, _c;

  if (level in SHADOWS) {
    return (_c = (_b = (_a = theme === null || theme === void 0 ? void 0 : theme.PLANE) === null || _a === void 0 ? void 0 : _a.SHADOWS) === null || _b === void 0 ? void 0 : _b[level]) !== null && _c !== void 0 ? _c : SHADOWS[level];
  } else {
    console.warn("\"".concat(level, "\" is not a valid option for a level.\n      Valid options are: ").concat(Object.keys(SHADOWS).join(', '), "."));
    return "";
  }
};

exports.getShadow = getShadow;